import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { getFormattedDate } from '../../../../../ui/issue-like-table/render-type/date-time';
import { dateRangeMessages } from './messages';
export var getDropdownLabel = function getDropdownLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anyTime';
  var formatMessage = arguments.length > 1 ? arguments[1] : undefined;
  var mapping = {
    anyTime: 'dateRangeAnyTime',
    today: 'dateRangeToday',
    yesterday: 'dateRangeYesterday',
    past7Days: 'dateRangeLastWeek',
    past30Days: 'dateRangeLastMonth',
    pastYear: 'dateRangeLastYear',
    custom: 'dateRangeCustom'
  };
  return formatMessage(dateRangeMessages[mapping[option]]);
};
export var getCurrentOptionLabel = function getCurrentOptionLabel(formatDate, formatMessage, value, to, from) {
  var selectedOption = value;
  if (selectedOption === 'custom') {
    var hasFromDate = !!from;
    var hasToDate = !!to;
    var formattedFromDate = getFormattedDate(from || '', 'date', formatDate);
    var formattedToDate = getFormattedDate(to || '', 'date', formatDate);
    if (hasFromDate && !hasToDate) {
      return formatMessage(dateRangeMessages.dateRangeAfterLabel, {
        date: formattedFromDate
      });
    }
    if (!hasFromDate && hasToDate) {
      return formatMessage(dateRangeMessages.dateRangeBeforeLabel, {
        date: formattedToDate
      });
    }
    if (hasFromDate && hasToDate) {
      return "".concat(formattedFromDate, " - ").concat(formattedToDate);
    }
  }
  return getDropdownLabel(selectedOption, formatMessage);
};
export var useInvalidDateRange = function useInvalidDateRange(from, to) {
  return useMemo(function () {
    if (!from && !to) {
      return null;
    }
    var dateFrom = new Date("".concat(from).concat(from ? 'T00:00:00' : ''));
    var dateTo = new Date("".concat(to).concat(to ? 'T00:00:00' : ''));
    var now = new Date();
    if (dateFrom > now) {
      return /*#__PURE__*/React.createElement(FormattedMessage, dateRangeMessages.dateRangeCustomInvalidDateAfterToday);
    }
    if (dateFrom > dateTo) {
      return /*#__PURE__*/React.createElement(FormattedMessage, dateRangeMessages.dateRangeCustomInvalidDateAfterEnd);
    }
    if (dateTo > now) {
      return /*#__PURE__*/React.createElement(FormattedMessage, dateRangeMessages.dateRangeCustomInvalidToDateAfterToday);
    }
    return null;
  }, [from, to]);
};